import * as Actions from "./actions";
import { initialState } from "../store/initialState";

export const BasesReducer = (state = initialState.bases, action) => {
  switch (action.type) {
    case Actions.DELETE_BASES:
      return {
        ...state,
        list: [...action.payload], //新しい配列として更新する。コンポーネント側で変更を検知するため。
      };
    case Actions.FETCH_BASES:
      return {
        ...state,
        list: [...action.payload], //新しい配列として更新する。コンポーネント側で変更を検知するため。
      };
    case Actions.INIT_BASES:
      return {
        ...initialState.bases,
      };
    default:
      return state;
  }
};
